import type { OpxSessionInfo } from 'owa-config-types';
import { overrideSessionId } from './getSessionId';

let promise: Promise<OpxSessionInfo> | undefined;
let hostApp: string = '(none)';

export function getOpxHostData(): Promise<OpxSessionInfo> | undefined {
    return promise;
}

export function getOpxHostApp(): string {
    return hostApp;
}

export function setOpxHostApp(app: string): void {
    hostApp = app;
}

export function setOpxHostData(value: Promise<OpxSessionInfo>): void {
    promise = value.then(opxHostData => {
        const sessionId = opxHostData.sessionId;
        if (sessionId) {
            overrideSessionId(sessionId);
        }
        return opxHostData;
    });
}
